module.exports = __webpack_public_path__ + "static/CardOfDarkness2-4d52cc08a2a555566b6768d55966e3cf.png";